import * as React from "react";
import { connect } from "react-redux";
import { webExclusiveProfilePicturePackageId } from "../../constants/webExclusives";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilPackage } from "../../utils/utilPackage";
import { DialogWithItems } from "../generic/dialog-with-items/DialogWithItems";
import { actionExpenseConfirmed } from "../item-packages/actionPackages";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var _DialogWebExclusivePackage = React.memo(function (_a) {
    var onClose = _a.onClose, onConfirm = _a.onConfirm;
    var itemsToDisplay = utilPackage.packageIdToDisplayableItems(webExclusiveProfilePicturePackageId);
    return (React.createElement(DialogWithItems, { title: IdLoca.webGiftDialog_title_web, description: IdLoca.webGiftDialog_desc_web, itemsToDisplay: itemsToDisplay, onConfirm: function () { return onConfirm(webExclusiveProfilePicturePackageId); }, onClose: onClose }));
});
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.WebExclusiveReward)); },
    onConfirm: function (packageId) {
        dispatch(actionExpenseConfirmed(packageId));
        dispatch(actionModalClose(IdModal.WebExclusiveReward));
    },
}); };
export var DialogWebExclusivePackage = connect(undefined, mapDispatch)(_DialogWebExclusivePackage);



//////////////////
// WEBPACK FOOTER
// ./src/features/web-exclusive-package/DialogWebExclusivePackage.tsx
// module id = 2962
// module chunks = 3